import type { WidgetDefinition, WidgetSection } from './types'

const _widgets = new Map<string, WidgetDefinition>()

export const WIDGET_REGISTRY = {
  register(def: WidgetDefinition): void {
    _widgets.set(def.id, def)
  },

  get(id: string): WidgetDefinition | undefined {
    return _widgets.get(id)
  },

  getAll(): WidgetDefinition[] {
    return [..._widgets.values()].sort((a, b) => a.order - b.order)
  },

  getBySection(section: WidgetSection): WidgetDefinition[] {
    return [..._widgets.values()]
      .filter((w) => w.section === section)
      .sort((a, b) => a.order - b.order)
  },

  has(id: string): boolean {
    return _widgets.has(id)
  },
} as const
